import React, { useCallback } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CAlert,
  CButton,
} from '@coreui/react-pro'
import Table from './Table'
import AddForm from './AddForm'
import { useState } from 'react'
import { useEffect } from 'react'
import RoundService from 'src/service/RoundService'
import ToastComponent from 'src/components/common/TaostComponent'
import Bootbox from 'bootbox-react'
import StepperBar from '../SetupProgress/StepperBar'
const Round = () => {
  const [users, setUsers] = useState([])
  const [roundNumber, setRoundNumber] = useState()
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState({})
  const [gameType, setGameType] = useState({})
  const [squadFixtureIds, setSquadFixtureIds] = useState([])

  // Use useCallback to memoize fetchUsers
  const fetchUsers = useCallback(async () => {
    setLoading(true)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    if (columnSorter && columnSorter.column !== undefined) {
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)
    }

    try {
      const result = await RoundService.getRound(offset, itemsPerPage, activePage, params)
      setUsers(result.data)
      setRoundNumber(result.rd_number)
      setGameType(result.game_type)
      setSquadFixtureIds(result.getRoundNotInFixture)
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter]) // Include dependencies

  // Include fetchUsers in the dependency array
  useEffect(() => {
    fetchUsers()
  }, [fetchUsers]) // Only fetchUsers as dependency here

  // Delete All confirm box
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])

  const toggleAllCheckboxes = () => {
    const allIds = squadFixtureIds.map((user) => user.id)
    setSelectedCheckboxes((prevSelected) => (prevSelected.length === allIds.length ? [] : allIds))
  }

  const [showDeleteAllConfirm, showShowDeleteAllConfirm] = useState(false)
  const showDeleteAllCofirmBox = () => {
    showShowDeleteAllConfirm(true)
  }
  const handleDeleteAllConfirm = () => {
    handleDeleteAllFixture()
    return showShowDeleteAllConfirm(false)
  }
  const handleDeleteAllCancel = () => {
    console.log('You clicked No!')
    return showShowDeleteAllConfirm(false)
  }
  const handleDeleteAllFixture = () => {
    const data = {
      roundIds: selectedCheckboxes, // Include the array of IDs here
    }

    RoundService.deleteAllRound(data).then((res) => {
      console.log('res', res)
      if (res.status === 200) {
        ToastComponent(res.message, 'success')
        setLoading(false)
        fetchUsers()
      } else {
        ToastComponent(res.message, 'error')
        setLoading(false)
      }
    })
  }
  const toggleCheckbox = (id) => {
    setSelectedCheckboxes((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((selectedId) => selectedId !== id)
      } else {
        return [...prevSelected, id]
      }
    })
  }
  return (
    <>
      <StepperBar activeStepKey="rounds" />
      <CRow>
        <CAccordion activeItemKey={1} alwaysOpen>
          {gameType == 4 && (
            <CAlert color="danger">Restriction: You can create a maximum of 1 Round only</CAlert>
          )}
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              {' '}
              <strong>Create Rounds</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <AddForm roundNumber={roundNumber} fetchUsers={fetchUsers} gameType={gameType} />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              {' '}
              <strong>Manage Rounds</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <CButton
                color="danger"
                className="mb-3"
                onClick={showDeleteAllCofirmBox}
                disabled={selectedCheckboxes.length === 0 ? 'true' : false}
              >
                Delete All
              </CButton>
              <Table
                users={users}
                setUsers={setUsers}
                setRoundNumber={setRoundNumber}
                fetchUsers={fetchUsers}
                setActivePage={setActivePage}
                setItemsPerPage={setItemsPerPage}
                setColumnFilter={setColumnFilter}
                setColumnSorter={setColumnSorter}
                itemsPerPage={itemsPerPage}
                activePage={activePage}
                columnFilter={columnFilter}
                columnSorter={columnSorter}
                selectedCheckboxes={selectedCheckboxes}
                squadFixtureIds={squadFixtureIds}
                toggleAllCheckboxes={toggleAllCheckboxes}
                toggleCheckbox={toggleCheckbox}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
      <Bootbox
        show={showDeleteAllConfirm}
        type={'confirm'}
        message={'Are you sure you want to delete all rounds?'}
        onSuccess={handleDeleteAllConfirm}
        onCancel={handleDeleteAllCancel}
        onClose={handleDeleteAllCancel}
      />
    </>
  )
}

export default Round
